import mapCacheClear from './_mapCacheClear';
import mapCacheDelete from './_mapCacheDelete';
import mapCacheGet from './_mapCacheGet';
import mapCacheHas from './_mapCacheHas';
import mapCacheSet from './_mapCacheSet';

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

export default MapCache;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_MapCache.js
// module id = null
// module chunks = 